// Module
var code = "<div id=\"V-E106D32A-61EA-46BE-B171-DF953963765A\"> <div data-b-component=\"input\" class=\"input\" data-b-comp-text=\"{Binding value}\"></div> </div> ";
// Exports
export default code;